module.exports = __webpack_public_path__ + "img/mind_background_2.36221ffa.png";